import React from 'react';

interface HeroSectionProps {
    className?: string;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ className = '' }) => {
    return (
        <section
            className={`bg-gradient-to-br from-bibi-blue to-bibi-blue/90 text-white py-12 md:py-16 ${className}`}
            aria-labelledby="hero-heading"
        >
            <div className="container mx-auto px-4 text-center">
                {/* Coming Soon Badge */}
                <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-6">
                    <span className="w-2 h-2 bg-sage-green rounded-full mr-2 animate-pulse" aria-hidden="true"></span>
                    Early Access • Founding Members Welcome
                </div>

                {/* Main Heading */}
                <h1
                    id="hero-heading"
                    className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"
                >
                    Stay Home. Stay Independent.
                    <br />
                    <span className="text-sage-green">Stay Connected.</span>
                </h1>                {/* Subtitle */}
                <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
                    BiBi brings affordable, reliable help to seniors from a unique network of caring community volunteers and trusted local professionals.
                </p>

                {/* Who We Are Content - Simplified */}
                <div className="max-w-3xl mx-auto mb-12">
                    <div className="space-y-6 text-center text-white/90 text-lg leading-relaxed">
                        <p>
                            <strong className="text-white">Built by neighbors, for neighbors.</strong> BiBi was founded in Wichita by a local entrepreneur who believes every senior deserves to age in the home they love, surrounded by community support. We connect the natural generosity in every neighborhood with the technology and safety systems that make help reliable and secure.
                        </p>
                    </div>
                </div>

                {/* CTA Hint */}
                <div className="mt-12">
                    <p className="text-white/70 text-sm">
                        ↓ Join our community below to be the first to know when we launch
                    </p>
                </div>
            </div>
        </section>
    );
};
